import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["cronExpression"]

  selectCron(event) {
    const expression = event.target.dataset.cronExpression
    const input = this.cronExpressionTarget
    
    if (input) {
      input.value = expression
      input.focus()
    }
  }
}